import App from 'next/app';
import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import NiceModal from '@ebay/nice-modal-react';
import { AuthContextProvider } from '$UTILS/hooks/useAuth';
import '$DATA/Less/merge.less';
import Head from 'next/head';
import useURLs from "$UTILS/hooks/useURLs";
import { HostConfig } from '../config/Host.config';
const { isLocal = false } = HostConfig?.Config || {};

function MyApp({ Component, pageProps }) {
  const data = useURLs({ ready: true });
  const pathname = typeof window !== 'undefined' ? window.location.pathname.split('/')[1] || 'm3-001' : 'm3-001';

  useEffect(() => {
    const HTML_ID = 'seonScriptTag';
    if (!document.getElementById(HTML_ID)) {
        const scriptLink = document.createElement("script");
        scriptLink.id = HTML_ID;
        scriptLink.src = "https://cdn.keepitsimple88.com/js/v6/agent.umd.js";
        scriptLink.type = "text/javascript";
        scriptLink.onload = () => {
            /**
             * Seon 在 Local端init時會隨機出現webpack__require錯誤，經嘗試無法排除，
             * 為避免影響開發，只在非Local環境執行seon.init
             */
            if (window?.seon && typeof window.seon.init === 'function' && !isLocal) {
                window.seon.init();
            }
        };
        document.querySelectorAll("head")[0].appendChild(scriptLink);
    }
  }, [isLocal]);

  return (
    <>
      <Head>
        <link rel="shortcut icon" href="/static/images/favicon.ico" />
        <title>
          {pathname === 'restrict' ? 'betway restriction page' : 'Betway必威体育官网，亞洲第一體育平台，立即下载手机版APP。'}
        </title>
      </Head>
      <ConfigProvider>
        <NiceModal.Provider>
          <AuthContextProvider>
            <Component {...pageProps} data={data} />
          </AuthContextProvider>
        </NiceModal.Provider>
      </ConfigProvider>
    </>
  );
}

export default MyApp;